import {
  AdminsView,
  ContactView,
  DeleteAccountView,
  getAdminAssessmentRedirectView,
  getAdminDashboardPaths,
  RedirectView,
  View,
} from '@hb/react-web'
import { adminAccess, superAdminAccess, userAccess } from '@hb/shared'
import { PracticeAssessmentsView } from './Views/Assessments'
import { BillingDashboardView } from './Views/Billing/BillingDashboardView'
import { ConsentFormsView } from './Views/ConsentForms'
import { PracticeInvoicesView } from './Views/Invoices'
import { PracticeContractsView } from './Views/PracticeContracts'
import { PracticeInfoView } from './Views/Practice/PracticeInfoView'
import { QAReportsView } from './Views/QAReports/QAReportsView'
import { SettingsView } from './Views/Settings/SettingsView'
import { SignInPage } from './Views/SignInPage'
import { VisitsView } from './Views/Visits/VisitsView'

const headerDashboardView: View = {
  name: 'Dashboard',
  path: getAdminDashboardPaths('providers-app'),
  // exact: true,
  component: PracticeAssessmentsView,
  access: adminAccess,
  onMenu: true,
}

const visitsView: View = {
  name: 'Visits',
  path: ['/visits', '/visits/:visitId'],
  component: VisitsView,
  access: adminAccess,
  onMenu: true,
}

const signInView: View = {
  name: 'Sign In',
  path: ['/', '/sign-in'],
  // exact: true,
  component: SignInPage,
}

const contactView: View = {
  name: 'Contact',
  path: '/contact',
  component: ContactView,
  onMenu: true,
}

const practiceInfoView: View = {
  name: 'Practice Info',
  path: ['/practice-info', '/practice-info/:displayedItem'],
  component: PracticeInfoView,
  access: adminAccess,
  onMenu: true,
  signIn: true,
}

const billingView: View = {
  name: 'Billing',
  path: ['/billing', '/billing/:encounterId'],
  component: BillingDashboardView,
  access: adminAccess,
  onMenu: true,
  signIn: true,
}

const adminsView: View = {
  name: 'Admins',
  path: ['/admins', '/admins/:adminId', '/admins/:adminId/:displayedItem'],
  component: AdminsView,
  access: adminAccess,
  signIn: true,
  onMenu: true,
}

const consentFormsView: View = {
  name: 'Consent Forms',
  path: '/consent-forms',
  component: ConsentFormsView,
  access: superAdminAccess,
  onMenu: true,
}
const practiceContractsView: View = {
  name: 'Practice Contracts',
  path: '/practice-contracts',
  component: PracticeContractsView,
  access: superAdminAccess,
  onMenu: true,
}
const invoicesView: View = {
  name: 'Invoices',
  path: [
    '/super-admin/invoices',
    '/super-admin/invoices/:invoicesTab',
    '/super-admin/invoices/:invoicesTab/:invoiceId',
  ],
  access: superAdminAccess,
  onMenu: true,
  component: PracticeInvoicesView,
}

const qaReportsView: View = {
  name: 'QA Reports',
  path: '/qa-reports',
  component: QAReportsView,
  access: adminAccess,
  onMenu: true,
  signIn: true,
}

const settingsView: View = {
  name: 'Settings',
  path: '/settings',
  component: SettingsView,
  access: userAccess,
  onMenu: true,
}

const deleteAccountView: View = {
  name: 'Delete Account',
  path: '/delete-account',
  component: DeleteAccountView,
}

const redirectView: View = {
  name: 'Redirect',
  path: '/*',
  component: RedirectView,
}

export const views: View[] = [
  signInView,
  getAdminAssessmentRedirectView('providers-app'),
  headerDashboardView,
  visitsView,
  billingView,
  contactView,
  practiceInfoView,
  adminsView,
  consentFormsView,
  practiceContractsView,
  qaReportsView,
  settingsView,
  invoicesView,
  deleteAccountView,
  redirectView,
]
